import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "deviceData-inverter",
  "use": "deviceData-inverter-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 17 17\" id=\"deviceData-inverter\">\r\n<style type=\"text/css\">\r\n\t#deviceData-inverter .st0{fill:none;}\r\n</style>\r\n<title>资源 3</title>\r\n<g id=\"deviceData-inverter_图层_2\">\r\n\t<g id=\"deviceData-inverter_编组_11备份_2\">\r\n\t\t<rect y=\"0\" class=\"st0\" width=\"17\" height=\"17\" />\r\n\t\t<path d=\"M15.6,1.9c0-0.5-0.5-0.9-1-0.9H2.3c0,0,0,0,0,0c-0.5,0-0.9,0.4-1,0.9v13.2c0,0.5,0.4,0.9,1,0.9h12.3c0,0,0,0,0,0\r\n\t\t\tc0.5,0,0.9-0.4,1-0.9L15.6,1.9C15.6,1.9,15.6,1.9,15.6,1.9z M4.5,5.1l8.3,0v1.3H4.5V5.1z\" />\r\n\t</g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/deviceData-inverter.svg
// module id = JyBt
// module chunks = 268